(function () {
    "use strict";

    // @ngInject
    function CreateNewMobileControllerCtor($scope, $injector, NavigationService, WorkspaceFileService, $stateParams, Enums) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CreateNewMobileController';
        this.NavigationService = NavigationService;
        this.WorkspaceFileService = WorkspaceFileService;
        this.$stateParams = $stateParams;
        this.Enums = Enums;
    }

    Controllers.CreateNewMobileController = Class(Controllers.BaseController, {
        constructor: CreateNewMobileControllerCtor,

        setBackToState: function setBackToState(itemType) {
            if (this.$stateParams && this.$stateParams.backToState) {
                this.NavigationService.setBackToState({ name: this.$stateParams.backToState.name, params: this.$stateParams.backToState.params })
            }
        }
    });
}());
